(function () {
  if (document.documentElement.dataset.zenShortVideosScriptLoaded === 'true') return;

  document.documentElement.dataset.zenShortVideosScriptLoaded = 'true';

  var sectionSelector = '[data-zen-short-videos]';
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileVideoNeedsGesture = window.matchMedia('(max-width: 749px), (pointer: coarse)').matches;

  function getSections(container) {
    var root = container || document;
    var sections = [];

    if (root.matches && root.matches(sectionSelector)) sections.push(root);

    return sections.concat(Array.prototype.slice.call(root.querySelectorAll(sectionSelector)));
  }

  function closestCard(element) {
    return element && element.closest('[data-zen-short-card]');
  }

  function getVideo(card) {
    return card && card.querySelector('video');
  }

  function initializeSection(section) {
    if (section.dataset.zenShortVideosInitialized === 'true') return;

    var track = section.querySelector('[data-zen-short-track]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-zen-short-card]'));
    var timelineProgress = section.querySelector('[data-zen-short-scrollbar]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-zen-short-dot]'));
    var prev = section.querySelector('[data-zen-short-prev]');
    var next = section.querySelector('[data-zen-short-next]');
    var resizeObserver = null;
    var ticking = false;
    var activeIndex = 0;
    var scrollLockIndex = null;
    var scrollLockTimer = null;
    var allowScrollActivation = false;
    var scrollIntentTimer = null;
    var userPaused = false;
    var needsGesture = mobileVideoNeedsGesture;
    var userStarted = false;
    var sectionIsVisible = false;
    var visibilityObserver = null;
    var cleanupCallbacks = [];

    if (!track || !cards.length) return;

    function isSectionVisibleEnough() {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      return rect.bottom > 80 && rect.top < viewportHeight - 80;
    }

    function updateMobileToggleState() {
      cards.forEach(function (card, index) {
        var toggle = card.querySelector('[data-zen-short-mobile-toggle]');
        var isPausedActiveCard = index === activeIndex && mobileVideoNeedsGesture && (userPaused || needsGesture);

        card.classList.toggle('is-user-paused', isPausedActiveCard);

        if (toggle) {
          toggle.setAttribute(
            'aria-label',
            isPausedActiveCard ? 'Videó indítása' : 'Videó szüneteltetése'
          );
        }
      });
    }

    function setProgress(card, ratio) {
      var clampedRatio = Math.max(0, Math.min(1, ratio || 0));

      if (card === cards[activeIndex] && timelineProgress) {
        timelineProgress.style.setProperty('--zen-short-video-progress', clampedRatio * 100 + '%');
      }
    }

    function disableScrollActivation() {
      allowScrollActivation = false;
      if (scrollIntentTimer) window.clearTimeout(scrollIntentTimer);
      scrollIntentTimer = null;
    }

    function markScrollIntent() {
      allowScrollActivation = true;
      if (scrollIntentTimer) window.clearTimeout(scrollIntentTimer);

      scrollIntentTimer = window.setTimeout(function () {
        allowScrollActivation = false;
        scrollIntentTimer = null;
      }, 900);
    }

    function syncSectionVisibility() {
      sectionIsVisible = isSectionVisibleEnough();

      if (sectionIsVisible) {
        renderState();
      } else {
        pauseCard(cards[activeIndex]);
      }
    }

    function updateVideoProgress(video) {
      var card = closestCard(video);
      var ratio = 0;

      if (video.duration && Number.isFinite(video.duration)) {
        ratio = video.currentTime / video.duration;
      }

      setProgress(card, ratio);
    }

    function pauseCard(card) {
      var video = getVideo(card);

      if (video) video.pause();
      if (card) card.classList.remove('is-playing');
    }

    function pauseInactiveVideos(activeCard) {
      cards.forEach(function (card) {
        if (card !== activeCard) pauseCard(card);
      });
    }

    function playActiveVideo() {
      var card = cards[activeIndex];
      var video = getVideo(card);

      pauseInactiveVideos(card);
      updateMobileToggleState();

      if (!card || !video || (mobileVideoNeedsGesture && needsGesture) || (prefersReducedMotion && !userStarted) || userPaused || !sectionIsVisible || card.classList.contains('is-product-open')) {
        if (video) pauseCard(card);
        if (!video && timelineProgress) {
          timelineProgress.style.setProperty('--zen-short-video-progress', '0%');
        }
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.preload = 'auto';

      if (video.ended) {
        video.currentTime = 0;
        setProgress(card, 0);
      }

      if (!video.paused) {
        card.classList.add('is-playing');
        return;
      }

      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise
          .then(function () {
            card.classList.add('is-playing');
          })
          .catch(function () {
            card.classList.remove('is-playing');
            needsGesture = mobileVideoNeedsGesture;
            updateMobileToggleState();
          });
      } else {
        card.classList.add('is-playing');
      }
    }

    function closePanels(exceptCard) {
      cards.forEach(function (card) {
        if (card === exceptCard) return;

        var toggle = card.querySelector('[data-zen-short-toggle]');
        var panel = card.querySelector('[data-zen-short-panel]');

        card.classList.remove('is-product-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      });
    }

    function scrollToIndex(index) {
      var card = cards[Math.max(0, Math.min(cards.length - 1, index))];
      if (!card) return;

      card.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }

    function findActiveIndex() {
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      cards.forEach(function (card, index) {
        var rect = card.getBoundingClientRect();
        var cardCenter = rect.left + rect.width / 2;
        var distance = Math.abs(trackCenter - cardCenter);

        if (distance < nearestDistance) {
          nearestIndex = index;
          nearestDistance = distance;
        }
      });

      return nearestIndex;
    }

    function renderState() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var activeCard = cards[activeIndex];
      var activeVideo = getVideo(activeCard);

      cards.forEach(function (card, index) {
        var isActive = index === activeIndex;
        card.classList.toggle('is-active', isActive);

        if (!isActive) pauseCard(card);
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
        dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });

      updateMobileToggleState();

      if (prev) prev.disabled = cards.length <= 1 || activeIndex <= 0;
      if (next) next.disabled = cards.length <= 1 || activeIndex >= cards.length - 1;

      if (activeVideo) {
        updateVideoProgress(activeVideo);
      } else if (timelineProgress) {
        timelineProgress.style.setProperty('--zen-short-video-progress', '0%');
      }

      playActiveVideo();
    }

    function activateIndex(index, shouldScroll) {
      activeIndex = Math.max(0, Math.min(cards.length - 1, index));
      renderState();

      if (shouldScroll !== false) {
        disableScrollActivation();
        scrollLockIndex = activeIndex;
        if (scrollLockTimer) window.clearTimeout(scrollLockTimer);

        scrollToIndex(activeIndex);

        scrollLockTimer = window.setTimeout(function () {
          scrollLockIndex = null;
          renderState();
        }, 650);
      }
    }

    function activateNextFromVideo() {
      var nextIndex = activeIndex + 1;

      if (nextIndex >= cards.length) nextIndex = 0;

      activateIndex(nextIndex, true);
    }

    function requestUpdate() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;

        if (scrollLockIndex !== null) {
          activateIndex(scrollLockIndex, false);
          return;
        }

        if (!allowScrollActivation) {
          renderState();
          return;
        }

        activateIndex(findActiveIndex(), false);
      });
    }

    function onTrackClick(event) {
      var mobileToggle = event.target.closest('[data-zen-short-mobile-toggle]');
      var toggle = event.target.closest('[data-zen-short-toggle]');
      var close = event.target.closest('[data-zen-short-close]');
      var media = event.target.closest('.zen-short-card__media');

      if (mobileToggle) {
        var mobileToggleCard = closestCard(mobileToggle);
        var mobileToggleIndex = cards.indexOf(mobileToggleCard);

        if (mobileToggleIndex >= 0) {
          closePanels(null);
          if (userPaused || needsGesture) {
            userPaused = false;
            needsGesture = false;
            userStarted = true;
          } else {
            userPaused = true;
          }

          activateIndex(mobileToggleIndex, true);
        }

        return;
      }

      if (toggle) {
        var toggleCard = closestCard(toggle);
        var toggleIndex = cards.indexOf(toggleCard);
        var panel = toggleCard && toggleCard.querySelector('[data-zen-short-panel]');
        var isOpen = toggleCard.classList.contains('is-product-open');

        closePanels(isOpen ? null : toggleCard);

        toggleCard.classList.toggle('is-product-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.setAttribute('aria-hidden', String(isOpen));

        if (toggleIndex >= 0) activateIndex(toggleIndex, true);

        if (!isOpen) {
          pauseCard(toggleCard);
        } else {
          playActiveVideo();
        }

        return;
      }

      if (close) {
        var closeCard = closestCard(close);
        var closeToggle = closeCard && closeCard.querySelector('[data-zen-short-toggle]');
        var closePanel = closeCard && closeCard.querySelector('[data-zen-short-panel]');
        var closeIndex = cards.indexOf(closeCard);

        closeCard.classList.remove('is-product-open');
        if (closeToggle) closeToggle.setAttribute('aria-expanded', 'false');
        if (closePanel) closePanel.setAttribute('aria-hidden', 'true');
        if (closeIndex >= 0) activateIndex(closeIndex, true);

        return;
      }

      if (media) {
        var mediaCard = closestCard(media);
        var mediaIndex = cards.indexOf(mediaCard);

        if (mediaIndex >= 0) {
          closePanels(null);
          needsGesture = false;
          userStarted = true;
          activateIndex(mediaIndex, true);
        }
      }
    }

    function onPrevious() {
      closePanels(null);
      needsGesture = false;
      userPaused = false;
      userStarted = true;
      activateIndex(activeIndex - 1, true);
    }

    function onNext() {
      closePanels(null);
      needsGesture = false;
      userPaused = false;
      userStarted = true;
      activateIndex(activeIndex + 1, true);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closePanels(null);
        playActiveVideo();
      }
    }

    function onVisibilityChange() {
      if (document.hidden) {
        pauseCard(cards[activeIndex]);
        return;
      }

      syncSectionVisibility();
    }

    function onWindowScroll() {
      requestUpdate();
      syncSectionVisibility();
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });
    track.addEventListener('wheel', markScrollIntent, { passive: true });
    track.addEventListener('touchstart', markScrollIntent, { passive: true });
    track.addEventListener('pointerdown', markScrollIntent);
    track.addEventListener('click', onTrackClick);
    window.addEventListener('scroll', onWindowScroll, { passive: true });
    window.addEventListener('resize', syncSectionVisibility);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('visibilitychange', onVisibilityChange);

    cleanupCallbacks.push(function () {
      track.removeEventListener('scroll', requestUpdate);
      track.removeEventListener('wheel', markScrollIntent);
      track.removeEventListener('touchstart', markScrollIntent);
      track.removeEventListener('pointerdown', markScrollIntent);
      track.removeEventListener('click', onTrackClick);
      window.removeEventListener('scroll', onWindowScroll);
      window.removeEventListener('resize', syncSectionVisibility);
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    });

    if (prev) {
      prev.addEventListener('click', onPrevious);
      cleanupCallbacks.push(function () {
        prev.removeEventListener('click', onPrevious);
      });
    }

    if (next) {
      next.addEventListener('click', onNext);
      cleanupCallbacks.push(function () {
        next.removeEventListener('click', onNext);
      });
    }

    dots.forEach(function (dot, index) {
      var onDotClick = function () {
        closePanels(null);
        needsGesture = false;
        userPaused = false;
        userStarted = true;
        activateIndex(index, true);
      };

      dot.addEventListener('click', onDotClick);
      cleanupCallbacks.push(function () {
        dot.removeEventListener('click', onDotClick);
      });
    });

    cards.forEach(function (card) {
      var video = getVideo(card);

      if (!video) return;

      var onTimeUpdate = function () {
        updateVideoProgress(video);
      };

      var onPlay = function () {
        if (card !== cards[activeIndex]) {
          pauseCard(card);
          return;
        }

        pauseInactiveVideos(card);
        card.classList.add('is-playing');
      };

      var onPause = function () {
        card.classList.remove('is-playing');
      };

      var onEnded = function () {
        card.classList.remove('is-playing');
        setProgress(card, 1);

        if (card === cards[activeIndex]) {
          activateNextFromVideo();
        }
      };

      video.addEventListener('timeupdate', onTimeUpdate);
      video.addEventListener('loadedmetadata', onTimeUpdate);
      video.addEventListener('play', onPlay);
      video.addEventListener('pause', onPause);
      video.addEventListener('ended', onEnded);

      cleanupCallbacks.push(function () {
        video.removeEventListener('timeupdate', onTimeUpdate);
        video.removeEventListener('loadedmetadata', onTimeUpdate);
        video.removeEventListener('play', onPlay);
        video.removeEventListener('pause', onPause);
        video.removeEventListener('ended', onEnded);
        video.pause();
      });
    });

    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== section) return;

            sectionIsVisible = entry.isIntersecting || isSectionVisibleEnough();

            if (sectionIsVisible) {
              renderState();
            } else {
              pauseCard(cards[activeIndex]);
            }
          });
        },
        { threshold: [0, 0.2, 0.55] }
      );

      visibilityObserver.observe(section);

      cleanupCallbacks.push(function () {
        visibilityObserver.disconnect();
      });
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(track);
      cleanupCallbacks.push(function () {
        resizeObserver.disconnect();
      });
    }

    section.dataset.zenShortVideosInitialized = 'true';
    section.zenShortVideosCleanup = function () {
      cleanupCallbacks.forEach(function (callback) {
        callback();
      });
      if (scrollLockTimer) window.clearTimeout(scrollLockTimer);
      if (scrollIntentTimer) window.clearTimeout(scrollIntentTimer);
      delete section.dataset.zenShortVideosInitialized;
      delete section.zenShortVideosCleanup;
    };

    window.setTimeout(function () {
      sectionIsVisible = isSectionVisibleEnough();
      activateIndex(findActiveIndex(), false);
    }, 120);
    window.setTimeout(syncSectionVisibility, 700);
  }

  function destroySection(section) {
    if (typeof section.zenShortVideosCleanup === 'function') {
      section.zenShortVideosCleanup();
    }
  }

  function initializeSections(container) {
    getSections(container).forEach(initializeSection);
  }

  function destroySections(container) {
    getSections(container).forEach(destroySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSections(document);
    });
  } else {
    initializeSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
